import Authorization from './Authorization';

const GuestAuthorization = Authorization(['guest']);
const FullUserAuthorization = Authorization(['full-user']);

export { Authorization, GuestAuthorization, FullUserAuthorization };
